"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPlacementPeuLiquiditeCorporation = void 0;
exports.ESubPlacementPeuLiquiditeCorporation = {
    scpi: "scpi",
    actions: "actions",
    livret_bancaire: "livret_bancaire",
};
